import { EmptyLayout, LayoutRoute, MainLayout } from './components/Layout';
import Authenticate from './components/Authenticate';
import PageSpinner from './components/PageSpinner';

import React from 'react';
import { BrowserRouter, Route, Switch, useSearchParams, Redirect  } from "react-router-dom";
import componentQueries from 'react-component-queries';
import { connect } from 'react-redux'

import { Provider } from "react-redux"
import store from "./store"

import Home from "./components/home"
import Callback from "./components/Auth/callback"
import Order from "./components/Order/order"
import SearchOrder from "./components/Search/searchorder"
import OrderConfirm from "./components/Order/confirm";
import DashboardPage from './pages/dashbaord';
import OrderSummary from "./components/Order/OrderSummary";
import PropertyReportForm from "./components/Property/PropertyReportForm";
import SearchProductPage from './pages/Admin/Product'
import ProductMain from './pages/Admin/Product/main'
import VendorMain from './pages/Vendor/main'
import ClientMain from './pages/Client/main'
import UserMain from './pages/Admin/User/index'
import EditUser from './pages/Admin/User/edit'
import OrderNoteForm from './components/Order/OrderNoteForm'
import CompanyProductMain from './pages/Admin/Company/index'
import './styles/custom-theme.scss';

class App extends React.Component {
  render() {




    console.log(this.props)

    
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route path="/callback" component={props => <Callback {...props} />} />
            <Authenticate>
              <MainLayout breakpoint={this.props.breakpoint}>
                            <React.Suspense fallback={<PageSpinner />}>
                                <Route path="/order-create" component={props => <Order {...props} />} />
                                <Route path="/neworder" component={props => <Order {...props} />} />
                                <Route exact path="/" component={props => <DashboardPage {...props} />} />
                                <Route path="/order-search" component={props => <SearchOrder {...props} />} />
                                <Route path="/confirm" component={props => <OrderConfirm {...props} />} />
                                <Route path="/property-report" component={props => <PropertyReportForm {...props} />} />
                                <Route path="/admin-product" component={props => <ProductMain {...props} />} />
                                <Route path="/admin-user" component={props => <UserMain {...props} />} />
                                <Route path="/order-edit" forceRefresh={true} component={props => <OrderSummary {...props} />} />
                                <Route path="/user-edit" component={props => <EditUser {...props} />} />
                                <Route path="/product-edit" component={props => <ProductMain {...props} />} />
                                <Route path="/Vendor" component={props => <VendorMain {...props} />} />
                                <Route path="/Client" component={props => <ClientMain {...props} />} />
                                <Route path="/Company" component={props => <CompanyProductMain {...props} />} />
                                <Route path="/order-search/addnote"   component={props => <OrderNoteForm {...props} />} />
                                
                            </React.Suspense>
              </MainLayout>
            </Authenticate>
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </Provider>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};

const mapStateToProps = state => {
  return { session: state.session }
}

export default componentQueries(query)(App);

